import { AppConfigModel } from "../../abstract/app-config.model";

export class BankAccountLineQualificationSource extends AppConfigModel {

    static override CLASS_NAME: string = 'BankAccountLineQualificationSource';
}
